var map = {
	"./-s-banner.png": 11379,
	"./001.png": 38697,
	"./002.png": 74162,
	"./003.png": 95707,
	"./004.png": 40900,
	"./01.png": 77571,
	"./02.png": 15592,
	"./03.png": 63985,
	"./174.png": 53172,
	"./1742.png": 64924,
	"./OCR识别.png": 2033,
	"./banner.png": 31236,
	"./codeQR.png": 7672,
	"./industry_solution.png": 13928,
	"./left.png": 55069,
	"./logo.png": 36959,
	"./quarod.png": 33652,
	"./right.png": 71966,
	"./scheme_structure.jpg": 33897,
	"./test.jpg": 23706,
	"./区域监控.png": 443,
	"./地理空间.png": 4482,
	"./地理空间_bg.png": 42342,
	"./工业生产.png": 71169,
	"./工地监控.png": 57049,
	"./工地监控背景.png": 64530,
	"./归档/001.png": 92415,
	"./归档/002.png": 7140,
	"./归档/003.png": 70381,
	"./归档/004.png": 40402,
	"./机房去监控.png": 56784,
	"./机房监控背景.png": 53416,
	"./物体检测背景.png": 59286,
	"./物体监测.png": 22506,
	"./电力 特种.png": 58182,
	"./电力特种背景.png": 84435,
	"./目标识别.png": 9442,
	"./背景点点-.png": 87714,
	"./自然语义.png": 41356,
	"./通用图标.png": 35353,
	"./通用背景.png": 31147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5091;